import React, { useState, useEffect, useCallback } from 'react'
import axios from '../../../../configAxios'
import ApplicationOverview from './applicationOverview/ApplicationOverview'
import { Route, Switch, withRouter} from 'react-router-dom'
import ApplicationsIndexBody from './ApplicationsIndexBody'

const PER_PAGE = 25

function ApplicationsIndex({ grantCampaign, isAdmin, match }) {

  const grantCampaignId = grantCampaign && grantCampaign.id
  const [applicationsList, setApplicationsList] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [page, setPage] = useState(1)
  const [totalCount, setTotalCount] = useState(0)

  // Keyed on the campaign id so it (and the effect below) refresh when the
  // campaign changes without a remount.
  const getApplications = useCallback((requestedPage) => {
    if (!grantCampaignId) return
    setIsLoading(true)
    // sc-28739: request one page at a time so a campaign with many applications
    // (and responses) doesn't time out (Heroku H12 -> infinite spinner). Cap the
    // request and always clear the loading state; the axios interceptor reports
    // the error, and we swallow the rejection so it isn't logged as unhandled.
    axios.get(`/grant_campaigns/${grantCampaignId}/grant_applications`, {
      params: { page: requestedPage, per_page: PER_PAGE },
      timeout: 60000,
    })
    .then(res => {
      setApplicationsList(res.data.json.data.grant_applications)
      setTotalCount(res.data.json.meta.total_count)
    })
    .catch(() => {})
    .finally(() => {
      setIsLoading(false)
    })
  }, [grantCampaignId])

  // Switching campaigns starts over at the first page.
  useEffect(() => {
    setPage(1)
  }, [grantCampaignId])

  useEffect(() => {
    getApplications(page)
  }, [page, getApplications])

  const handlePageClick = ({ selected }) => setPage(selected + 1)

  return (
    <div className="container w-100 p-0">
      {grantCampaign && applicationsList &&
      <Switch>
        <Route
          path={match.path + "/show/:application_id"}
          exact
          render={routeProps =>
            <ApplicationOverview
              {...routeProps}
              grantCampaign={grantCampaign}
              isAdmin={isAdmin}
            />
          }
        />
        {/* TODO: Reorganize the routes so /show above isn't required */}
        <Route
          path="/campaigns/:campaign_id/applications"
          render={routeProps => {
            return <ApplicationsIndexBody
              grantCampaign={grantCampaign}
              applicationsList={applicationsList}
              isLoading={isLoading}
              page={page}
              perPage={PER_PAGE}
              totalCount={totalCount}
              handlePageClick={handlePageClick}
              {...routeProps}
            />
            }}
        />
      </Switch>
}
    </div>
  )
}

export default withRouter(ApplicationsIndex)
